<template>
  <div>
    <h2 class="purple">Central Illinois Wing Riders</h2>
    <p id="charter">Established November 12, 1995</p>
    <p class="subheading">Friends for Fun, Safety, and Riding</p>
    <p>
      Monthly socials are the fourth Sunday of the month at
      <a href="https://maps.app.goo.gl/1DacHHKcCCWL5pc8A" target="_blank" rel="noopener noreferrer">Avanti's East Peoria, 2320 E Washington St, East Peoria, IL</a>
      <br />
      We eat at 5:00 pm with our meeting at 6:00pm.
    </p>
    <p>
      <strong>Ice Cream:&nbsp;&nbsp;</strong>Second and Fourth Thursday of the
      month at 6:00 pm. <br />See calendar for date and location.
    </p>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
